<template>
  <td v-if="renderCell" :class="className" class='text-left'
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell">
    {{ formatDate(getNestedValue(field, dataItem)) }}
  </td>
  <td
    v-else-if="renderArrow"
    key="'g' + columnIndex"
    :class="'k-group-cell'"
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell"
  ></td>
  <td
    v-else-if="columnIndex <= level"
    key='g-colspan'
    :colSpan="columnsCount - columnIndex"
    :data-grid-col-index="columnIndex"  
    role="gridcell"
  >
    <p class='k-reset'>
      <a
        @click="onClick"
        tabIndex='-1'
        href='#'
        :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'"
      />
      {{ dataItem[field] }}
    </p>
  </td>
</template>
<script>
import moment from 'moment'

function nestedValue (fieldName, dataItem) {
  const path = fieldName.split('.')
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })

  return data
}

export default {
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      return returnValue && this.dataItem[this.field]
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    formatDate: function (strDate) {
      if (!this.isDate(strDate)) return strDate
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    isDate: function (strDate) {
      if (strDate === undefined || strDate === null) return false
      const year = new Date(strDate).getFullYear()
      if (year >= 2000) return true
      return false
    },
    getNestedValue: nestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
